import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Modal, Field } from '../ui/Modal';
import { Icon } from '../ui/Icon';
import { api, ApiError } from '../../lib/api';
import { toast } from '../../stores/toast.store';

export function NewMilestoneModal({ onClose, projectId }: { onClose: () => void; projectId: string }) {
  const qc = useQueryClient();
  const [label, setLabel] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [active, setActive] = useState(false);

  const create = useMutation({
    mutationFn: () => api.post(`/projects/${projectId}/milestones`, {
      label,
      dueDate,
      active,
      done: false,
    }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['project', projectId] });
      toast.ok('Milestone creata', label);
      onClose();
    },
    onError: (err) => toast.alert('Errore creazione milestone', err instanceof ApiError ? err.message : 'Riprova'),
  });

  return (
    <Modal
      title="Nuova milestone"
      kicker="Timeline · Piano progetto"
      onClose={onClose}
      size="md"
      footer={
        <>
          <button className="btn btn-ghost" onClick={onClose}>Annulla</button>
          <div className="spacer" />
          <button className="btn btn-primary" onClick={() => create.mutate()} disabled={!label || !dueDate || create.isPending}>
            Crea <Icon name="arrowRight" size={12} />
          </button>
        </>
      }
    >
      <div className="form-grid">
        <Field label="Etichetta" required span={12}>
          <input className="inp" placeholder="es. UAT, Go-live, Discovery..." value={label} onChange={(e) => setLabel(e.target.value)} autoFocus />
        </Field>
        <Field label="Scadenza" required span={6}>
          <input className="inp mono" type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} />
        </Field>
        <Field label="" span={6}>
          <label className="flex items-center gap-2 text-[13px] mt-6">
            <input type="checkbox" checked={active} onChange={(e) => setActive(e.target.checked)} />
            Milestone attiva ora
          </label>
        </Field>
      </div>
    </Modal>
  );
}
